export default __webpack_public_path__ + "static/media/icon_login_social_google.a1ea1dfc.svg";